export const listMutations = <const>{
	SKLAD_OV_FILTER_TYPKOD: 'SKLAD_OV_FILTER_TYPKOD',
};

export const editMutations = <const>{
	MODEL_NV_SELECT: 'MODEL_NV_SELECT',
	MODEL_OV_SELECT: 'MODEL_OV_SELECT',
	PRODAVAJICI_SELECT: 'PRODAVAJICI_SELECT',
	PNEU_POPIS_SELECT: 'POPIS_PNEU_SELECT',
	BARVA_SELECT: 'BARVA_SELECT',
	NAKLADOVE_STREDISKO_SELECT: 'NAKLADOVE_STREDISKO_SELECT',
};
